"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = PremiumImageBanner;
const react_1 = __importDefault(require("react"));
const PremiumImageBanner_module_scss_1 = __importDefault(require("./PremiumImageBanner.module.scss"));
const dispatchAnalytics_1 = require("../../../utils/dispatchAnalytics");
function PremiumImageBanner({ ctaLink, clickUrl, impressionUrl, associatedAdvertId, desktopImage, accessibilityText, esiType, }) {
    return (react_1.default.createElement("a", { href: ctaLink, className: PremiumImageBanner_module_scss_1.default.bannerLink, "data-testid": "nav-flyout-premium-image-banner-link", onClick: () => {
            (0, dispatchAnalytics_1.dispatchKevelAnalyticsEvent)({
                action: "kevel.clicked",
                type: "banner",
                adId: associatedAdvertId,
                clickUrl,
                impressionUrl,
                esiType,
            });
        } },
        react_1.default.createElement("picture", null,
            react_1.default.createElement("source", { media: "(min-width: 1440px)", srcSet: `
            ${desktopImage}?w=1263&h=145&fmt=auto 1x,
            ${desktopImage}?w=2526&h=290&fmt=auto 2x
          ` }),
            react_1.default.createElement("source", { media: "(min-width: 1280px)", srcSet: `
            ${desktopImage}?w=941&h=145&fmt=auto 1x,
            ${desktopImage}?w=1882&h=290&fmt=auto 2x
          ` }),
            react_1.default.createElement("img", { "data-testid": "nav-flyout-premium-image-banner-image", src: `${desktopImage}?w=941&h=145&fmt=auto`, className: PremiumImageBanner_module_scss_1.default.bannerImage, alt: accessibilityText }))));
}
